import React, { useState } from 'react';
import RemoteLogin from './RemoteLogin';
import UserStatus from './UserStatus';
import './App.css';

function App() {
  const [showUserStatus, setShowUserStatus] = useState(false);

  return (
    <div className="app-container">
      {showUserStatus ? (
        <UserStatus onBack={() => setShowUserStatus(false)} />
      ) : (
        <RemoteLogin onShowUserStatus={() => setShowUserStatus(true)} />
      )}
    </div>
  );
}

export default App;
